import React, { RefObject, useEffect, useRef } from 'react'
import {
  default as CustomScrollbar,
  ScrollbarProps,
} from 'react-custom-scrollbars'
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock'

function Scrollbar(props: ScrollbarProps & {disableAutoBlocking?: boolean}) {
  const ref: RefObject<any> = useRef()
  const {disableAutoBlocking, ...rest} = props

  useEffect(() => {
    if(disableAutoBlocking) return
    const { current } = ref

    disableBodyScroll(current.view)
    return () => {
      enableBodyScroll(current.view)
    }
  }, [disableAutoBlocking])

  return <CustomScrollbar ref={ref} {...rest} />
}

export default Scrollbar
